import { render, staticRenderFns } from "./TextBodyDialog.vue?vue&type=template&id=ed02f9b0&"
import script from "./TextBodyDialog.vue?vue&type=script&lang=ts&"
export * from "./TextBodyDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports